$(function() {
  var Pattern = {
    USERNAME: /^[a-z0-9\_\.\-\@\ \-]{3,32}$/i,
    EMAIL: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  };

  var accountForm = $('#create-account .checkout-form');

  if (accountForm.length === 0) {
    return;
  }

  var usernameInput = accountForm.find('input[name=username]');
  var emailInput = accountForm.find('input[name=email]');
  var passwordInput = accountForm.find('input[name=password]');
  var confirmPasswordInput = accountForm.find('input[name=confirmPassword]');
  var igsearch = accountForm.find('.input-group-igusername');
  var subscription = accountForm.find('input[name=subscription]');
  var subscriptionPassword = accountForm.find('input[name=subscriptionPassword]');
  var submits = accountForm.find('button[type=submit]');

  igsearch.search({
    onInput: function(username, auto) {
      var self = this;

      self.loading(true);

      igResource.search(username, {
        success: function(users) {
          var items = [];
          var selectedItem;
          for (var i = 0; i < users.length; i++) {
            var user = users[i];
    
            var iguser = self.createItem();
    
            iguser.attr('data-value', user.username);
            iguser.find('.profile').attr('src', 'https://ximg.automaticviral.com/' + user.picture);
            iguser.find('.name .username').html(user.username);
            iguser.find('.name .fullname').html(user.full_name);
            iguser.find('.followers .count').html(avFormat.niceNumber(user.followers, 0, 1000));

            if (auto && username === user.username) {
              selectedItem = iguser;
            }

            items.push(iguser);
          }

          if (selectedItem) {
            self.bindSelection(selectedItem);
          }

          self.bindItems(items);
        },
        error: function(xhr, status, err) {
          AVNotify(err, 'danger');
        },
        complete: function() {
          self.loading(false);
        }
      });
    }
  });

  var requiredInputs = accountForm.find('input[required]');

  // validation
  var validate = function() {
    var valid = true;
    accountForm.find('.invalid > input').each(function() {
      $(this).setValid();
    });

    var username = usernameInput.val();
    if (!username.match(Pattern.USERNAME)) {
      valid = false;
      usernameInput.setInvalid();
    }

    var email = emailInput.val();
    if (!email.match(Pattern.EMAIL)) {
      valid = false;
      emailInput.setInvalid();
    }

    var password = passwordInput.val();
    if (password.length < 3 || password.length > 255) {
      valid = false;
      passwordInput.setInvalid();
    }

    var confirmPassword = confirmPasswordInput.val();
    if (password !== confirmPassword) {
      valid = false;
      confirmPasswordInput.setInvalid();
    }

    var igusername = igsearch.val();
    if (!(igusername.match(/^[a-z0-9\.\-\_]{1,32}$/i) && igsearch.isSelected())) {
      valid = false;
      igsearch.setRequired();
    }

    requiredInputs.each(function() {
      var requiredInput = $(this);
      if (!requiredInput.val()) {
        valid = false;
        requiredInput.setRequired();
      }
    });

    return valid;
  };

  requiredInputs.bind('change keyup input', function() {
    $(this).setValid();
  });

  submits.on('click.account', function(e) {
    e.preventDefault();

    var submit = $(this);

    if (!validate()) {
      return false;
    }

    submits.prop('disabled', true);
    submit.addClass('btn-loading');

    var data = {
      username: usernameInput.val(),
      email: emailInput.val(),
      password: passwordInput.val(),
      confirmPassword: confirmPasswordInput.val(),
      igusername: igsearch.val(),
      subscription: subscription.val(),
      subscriptionPassword: subscriptionPassword.val()
    };

    userResource.add(data, {
      success: function(resp) {
        if (resp.redirectUrl) {
          // Just redirect the user
          window.location.href = resp.redirectUrl;
        }
      },
      error: function(xhr, status, err) {
        var json = xhr.responseJSON;
        if (json) {
          var input;
          if (json.validation && Array.isArray(json.validation.keys)) {
            var key = json.validation.keys[0];
            input = accountForm.find('input[name=' + key + ']');
          }

          if (input && xhr.status === 409) {
            input.setConflict();
          } else if (input && xhr.status === 400) {
            input.setInvalid();
          } else {
            AVNotify(json.message || err, 'danger');
          }
        } else {
          AVNotify(err, 'danger');
        }
        
        submits.prop('disabled', false);
        submit.removeClass('btn-loading');
      }
    });
  });
        
  submits.prop('disabled', false);
  submits.removeClass('btn-loading');
});